/**
 * Routing for `/` and `/auth` — the marketing start screen.
 *
 * Firebase keeps an anonymous "Try Gift Gaff" session after the tab closes, but
 * searching gift-gaff.com must still show Try Gift Gaff / Login unless the
 * visitor is a real account holder. In-app conversion stays on
 * `/auth?intent=create-account` and `/auth?intent=login`.
 */

/**
 * True when a signed-in account holder should skip the start screen and enter
 * the app. Guests and signed-out visitors always stay on the landing page.
 *
 * @param {{
 *   isSignedIn?: boolean,
 *   isGuest?: boolean,
 *   profileComplete?: boolean,
 *   hasConversionIntent?: boolean,
 * }} [opts]
 */
export function shouldEnterAppFromAuthLanding({
  isSignedIn = false,
  isGuest = false,
  profileComplete = false,
  hasConversionIntent = false,
} = {}) {
  if (hasConversionIntent) return false;
  if (!isSignedIn || isGuest) return false;
  return Boolean(profileComplete);
}

/**
 * Close on an in-app conversion flow returns a guest to the app. Close on Login
 * opened from the start screen returns to the start screen so they can pick
 * a different path.
 *
 * @param {{
 *   isGuest?: boolean,
 *   targetIsStart?: boolean,
 *   hasConversionIntent?: boolean,
 * }} [opts]
 */
export function shouldReturnGuestToAppOnAuthClose({
  isGuest = false,
  targetIsStart = false,
  hasConversionIntent = false,
} = {}) {
  return Boolean(isGuest && targetIsStart && hasConversionIntent);
}
